import { STRINGS } from '@/constants/strings';
import ForgotPasswordLinkSentScreen from '@/features/auth/screens/forgot-password-link-sent-screen';
import ForgotPasswordV1Screen from '@/features/auth/screens/forgot-password-v1-screen';
import LoginScreen from '@/features/auth/screens/login-screen';
import LoginWithBiometricsScreen from '@/features/auth/screens/login-with-biometrics';
import SignUpScreen from '@/features/auth/screens/signup-screen';
import VerifyEmailLinkSentScreen from '@/features/auth/screens/verify-email-link-sent-screen';
import { WelcomeScreen } from '@/features/auth/screens/welcome-screen';
import { publicScreens } from '@/navigations/public-stack';
import type { UnAuthStackParamList } from '@/navigations/types';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import React from 'react';

const Stack = createNativeStackNavigator<UnAuthStackParamList>();

export function UnAuthStack() {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
        animation: 'slide_from_right',
        title: STRINGS.appDocumentTitle,
      }}>
      <Stack.Screen name="Welcome" component={WelcomeScreen} />
      <Stack.Screen name="Login" component={LoginScreen} />
      <Stack.Screen name="LoginWithBiometrics" component={LoginWithBiometricsScreen} />
      <Stack.Screen name="SignUp" component={SignUpScreen} />
      <Stack.Screen name="ForgotPassword" component={ForgotPasswordV1Screen} />
      <Stack.Screen name="ForgotPasswordLinkSent" component={ForgotPasswordLinkSentScreen} />
      <Stack.Screen name="VerifyEmailLinkSent" component={VerifyEmailLinkSentScreen} />
      {publicScreens.map(screen => (
        <Stack.Screen key={screen.name} name={screen.name} component={screen.component} />
      ))}
    </Stack.Navigator>
  );
}
